(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  ready(function () {
    var body = document.body;
    var sidebar = document.getElementById('ncHeaderSidebar');
    var header = document.getElementById('velaHeader');
    var toggle = document.querySelector('[data-nc-header-sidebar-toggle]');

    if (!body || !sidebar || !toggle) {
      return;
    }

    var mobileCartCount = document.getElementById('CartCount');
    var mobileCartCost = document.getElementById('CartCost');
    var desktopCartCount = document.querySelector('[data-nc-cart-count]');
    var desktopCartCost = document.querySelector('[data-nc-cart-cost]');
    var cartMediaQuery = window.matchMedia ? window.matchMedia('(min-width: 992px)') : null;
    var syncingCart = false;

    function setElementId(element, id, enabled) {
      if (!element) {
        return;
      }

      if (enabled) {
        element.setAttribute('id', id);
        return;
      }

      if (element.getAttribute('id') === id) {
        element.removeAttribute('id');
      }
    }

    function syncCartText(sourceCount, sourceCost) {
      if (syncingCart || !sourceCount) {
        return;
      }

      syncingCart = true;

      if (mobileCartCount && sourceCount !== mobileCartCount && mobileCartCount.textContent !== sourceCount.textContent) {
        mobileCartCount.textContent = sourceCount.textContent;
      }

      if (desktopCartCount && sourceCount !== desktopCartCount && desktopCartCount.textContent !== sourceCount.textContent) {
        desktopCartCount.textContent = sourceCount.textContent;
      }

      if (sourceCost) {
        if (mobileCartCost && sourceCost !== mobileCartCost && mobileCartCost.textContent !== sourceCost.textContent) {
          mobileCartCost.textContent = sourceCost.textContent;
        }

        if (desktopCartCost && sourceCost !== desktopCartCost && desktopCartCost.textContent !== sourceCost.textContent) {
          desktopCartCost.textContent = sourceCost.textContent;
        }
      }

      syncingCart = false;
    }

    function assignCartIds() {
      var isDesktop = cartMediaQuery ? cartMediaQuery.matches : window.innerWidth >= 992;

      setElementId(desktopCartCount, 'CartCount', isDesktop);
      setElementId(mobileCartCount, 'CartCount', !isDesktop);
      setElementId(desktopCartCost, 'CartCost', isDesktop);
      setElementId(mobileCartCost, 'CartCost', !isDesktop);

      syncCartText(isDesktop ? desktopCartCount : mobileCartCount, isDesktop ? desktopCartCost : mobileCartCost);
    }

    function updateSidebarOffset() {
      if (!header) {
        return;
      }

      sidebar.style.setProperty('--nc-header-sidebar-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
    }

    function openSidebar() {
      updateSidebarOffset();
      body.classList.add('ncHeaderSidebarOpen');
      sidebar.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeSidebar() {
      body.classList.remove('ncHeaderSidebarOpen');
      sidebar.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
    }

    function closeSidebarIfOpen() {
      if (body.classList.contains('ncHeaderSidebarOpen')) {
        closeSidebar();
      }
    }

    function getMegaMenuTrigger(item) {
      if (!item || !item.children) {
        return null;
      }

      return item.children[0] && item.children[0].tagName === 'A' ? item.children[0] : null;
    }

    function closeMegaMenuItem(item) {
      var menu = item ? item.querySelector('.ncMegaMenu') : null;
      var trigger = getMegaMenuTrigger(item);

      if (!item) {
        return;
      }

      item.classList.remove('is-open');
      clearMegaColumnState(menu);

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    }

    function closeAllMegaMenus(exceptItem) {
      Array.prototype.forEach.call(document.querySelectorAll('#velaHeader .ncHeaderMegamenu .ncMegaMenuItem.is-open'), function (item) {
        if (item !== exceptItem) {
          closeMegaMenuItem(item);
        }
      });
    }

    function openMegaMenuItem(item) {
      var trigger = getMegaMenuTrigger(item);

      if (!item) {
        return;
      }

      closeSidebarIfOpen();
      closeAllMegaMenus(item);
      item.classList.add('is-open');

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }
    }

    function toggleMegaMenuItem(item) {
      if (!item) {
        return;
      }

      if (item.classList.contains('is-open')) {
        closeMegaMenuItem(item);
        return;
      }

      openMegaMenuItem(item);
    }

    function logFourthMenuDebug() {
      var params;
      var items;
      var rows;

      try {
        params = new URLSearchParams(window.location.search);
      } catch (error) {
        return;
      }

      if (!params.has('nc_menu_debug') || !window.console || !console.table) {
        return;
      }

      items = document.querySelectorAll('[data-nc-fourth-debug]');
      rows = Array.prototype.map.call(items, function (item) {
        return {
          label: item.getAttribute('data-nc-fourth-label'),
          hasMenu: item.getAttribute('data-nc-fourth-has-menu'),
          foundHandle: item.getAttribute('data-nc-fourth-found-handle'),
          foundLinks: item.getAttribute('data-nc-fourth-found-links'),
          labelHandle: item.getAttribute('data-nc-fourth-label-handle'),
          labelAndHandle: item.getAttribute('data-nc-fourth-label-and-handle'),
          collectionTitleHandle: item.getAttribute('data-nc-fourth-collection-title-handle'),
          linkHandle: item.getAttribute('data-nc-fourth-link-handle'),
          urlHandle: item.getAttribute('data-nc-fourth-url-handle'),
          knownTableTitle: item.getAttribute('data-nc-fourth-known-table-title'),
          knownTableLinks: item.getAttribute('data-nc-fourth-known-table-links'),
          labelTitle: item.getAttribute('data-nc-fourth-label-title'),
          labelLinks: item.getAttribute('data-nc-fourth-label-links'),
          labelAndTitle: item.getAttribute('data-nc-fourth-label-and-title'),
          labelAndLinks: item.getAttribute('data-nc-fourth-label-and-links'),
          collectionTitle: item.getAttribute('data-nc-fourth-collection-title'),
          collectionLinks: item.getAttribute('data-nc-fourth-collection-links'),
          handleTitle: item.getAttribute('data-nc-fourth-handle-title'),
          handleLinks: item.getAttribute('data-nc-fourth-handle-links'),
          urlTitle: item.getAttribute('data-nc-fourth-url-title'),
          urlLinks: item.getAttribute('data-nc-fourth-url-links'),
          linkType: item.getAttribute('data-nc-fourth-link-type')
        };
      });

      console.table(rows);
    }

    function clearMegaFourthState(menu) {
      if (!menu) {
        return;
      }

      menu.classList.remove('is-fourth-active');

      Array.prototype.forEach.call(menu.querySelectorAll('.is-active, .is-column-active'), function (item) {
        item.classList.remove('is-active', 'is-column-active');
      });

      Array.prototype.forEach.call(menu.querySelectorAll('.ncMegaMenuThirdItem.hasFourthMenu > a[aria-expanded="true"]'), function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function updateMegaMenuImage(menu, trigger) {
      var imageWrapper;
      var image;
      var imageLink;
      var src;
      var alt;
      var href;

      if (!menu || !trigger) {
        return false;
      }

      src = trigger.getAttribute('data-nc-menu-image-src');

      if (!src) {
        return false;
      }

      imageWrapper = menu.querySelector('.ncMegaMenuImage');
      image = imageWrapper ? imageWrapper.querySelector('img') : null;

      if (!image) {
        return false;
      }

      alt = trigger.getAttribute('data-nc-menu-image-alt') || image.getAttribute('alt') || '';
      href = trigger.getAttribute('data-nc-menu-image-link') || trigger.getAttribute('href') || '';
      imageLink = imageWrapper.querySelector('a');

      if (image.getAttribute('src') !== src) {
        image.setAttribute('src', src);
      }

      image.setAttribute('alt', alt);

      if (imageLink && href) {
        imageLink.setAttribute('href', href);
      }

      return true;
    }

    function clearMegaColumnState(menu) {
      if (!menu) {
        return;
      }

      clearMegaFourthState(menu);

      Array.prototype.forEach.call(menu.querySelectorAll('.ncMegaMenuColumn.is-open'), function (column) {
        var heading = column.querySelector('.ncMegaMenuHeading');

        column.classList.remove('is-open');

        if (heading) {
          heading.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function openMegaColumnFromHeading(heading) {
      var menu = heading ? heading.closest('.ncMegaMenu') : null;
      var column = heading ? heading.closest('.ncMegaMenuColumn') : null;

      if (!menu || !column) {
        return;
      }

      clearMegaColumnState(menu);
      column.classList.add('is-open');
      heading.setAttribute('aria-expanded', 'true');

      updateMegaMenuImage(menu, heading);
    }

    function activateMegaFourthItem(item) {
      var menu = item.closest('.ncMegaMenu');
      var column = item.closest('.ncMegaMenuColumn');
      var trigger = item.querySelector('a');

      clearMegaFourthState(menu);

      if (!menu || !column) {
        return;
      }

      menu.classList.add('is-fourth-active');
      column.classList.add('is-column-active');
      item.classList.add('is-active');

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }
    }

    function toggleMegaFourthItem(item) {
      var menu = item ? item.closest('.ncMegaMenu') : null;

      if (!item || !menu) {
        return;
      }

      if (item.classList.contains('is-active')) {
        clearMegaFourthState(menu);
        return;
      }

      activateMegaFourthItem(item);
    }

    function getMegaColumnHeadingFromEvent(event) {
      var heading = event.target.closest('.ncMegaMenuHeading');

      if (!heading || !heading.parentNode || !heading.parentNode.classList.contains('ncMegaMenuColumn')) {
        return null;
      }

      return heading;
    }

    function getMegaThirdTriggerFromEvent(event) {
      var trigger = event.target.closest('a');

      if (!trigger || !trigger.parentNode || !trigger.parentNode.classList.contains('ncMegaMenuThirdItem')) {
        return null;
      }

      return trigger;
    }

    Array.prototype.forEach.call(document.querySelectorAll('#velaHeader .ncHeaderMegamenu .ncMegaMenuHeading'), function (heading) {
      heading.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('#velaHeader .ncHeaderMegamenu .ncMegaMenuItem'), function (item) {
      var trigger = getMegaMenuTrigger(item);

      if (!trigger) {
        return;
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        toggleMegaMenuItem(item);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();
        toggleMegaMenuItem(item);
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('.ncMegaMenu'), function (menu) {
      menu.addEventListener('mouseover', function (event) {
        var imageTrigger = event.target.closest('[data-nc-menu-image-src]');

        if (imageTrigger && menu.contains(imageTrigger)) {
          updateMegaMenuImage(menu, imageTrigger);
        }
      });

      menu.addEventListener('focusin', function (event) {
        closeSidebarIfOpen();

        var imageTrigger = event.target.closest('[data-nc-menu-image-src]');

        if (imageTrigger && menu.contains(imageTrigger)) {
          updateMegaMenuImage(menu, imageTrigger);
        }
      });

      menu.addEventListener('mouseleave', function () {
        clearMegaFourthState(menu);
      });

      menu.addEventListener('focusout', function (event) {
        if (!menu.contains(event.relatedTarget)) {
          clearMegaFourthState(menu);
        }
      });

      menu.addEventListener('click', function (event) {
        var heading = getMegaColumnHeadingFromEvent(event);
        var thirdTrigger = getMegaThirdTriggerFromEvent(event);
        var thirdItem = thirdTrigger ? thirdTrigger.parentNode : null;

        if (thirdTrigger && menu.contains(thirdTrigger)) {
          if (thirdItem.classList.contains('hasFourthMenu')) {
            event.preventDefault();
            toggleMegaFourthItem(thirdItem);
            return;
          }

          clearMegaFourthState(menu);
          return;
        }

        if (heading && menu.contains(heading)) {
          clearMegaFourthState(menu);
          return;
        }

        if (event.target.closest('a, button, li')) {
          clearMegaFourthState(menu);
        }
      });

      menu.addEventListener('keydown', function (event) {
        var heading = getMegaColumnHeadingFromEvent(event);
        var thirdTrigger = getMegaThirdTriggerFromEvent(event);
        var thirdItem = thirdTrigger ? thirdTrigger.parentNode : null;

        if (thirdTrigger && menu.contains(thirdTrigger) && (event.key === 'Enter' || event.key === ' ')) {
          if (thirdItem.classList.contains('hasFourthMenu')) {
            event.preventDefault();
            toggleMegaFourthItem(thirdItem);
            return;
          }

          clearMegaFourthState(menu);
          return;
        }

        if (heading && menu.contains(heading)) {
          clearMegaFourthState(menu);
        }
      });
    });

    toggle.addEventListener('click', function () {
      if (body.classList.contains('ncHeaderSidebarOpen')) {
        closeSidebar();
        return;
      }

      closeAllMegaMenus();
      openSidebar();
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('#velaHeader .ncHeaderMegamenu .ncMegaMenuItem')) {
        closeAllMegaMenus();
      }

      if (!body.classList.contains('ncHeaderSidebarOpen')) {
        return;
      }

      if (sidebar.contains(event.target) || toggle.contains(event.target)) {
        return;
      }

      closeSidebar();
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') {
        closeSidebar();
        closeAllMegaMenus();
      }
    });

    window.addEventListener('resize', updateSidebarOffset);
    window.addEventListener('scroll', function () {
      if (body.classList.contains('ncHeaderSidebarOpen')) {
        updateSidebarOffset();
      }
    }, { passive: true });

    assignCartIds();
    updateSidebarOffset();
    logFourthMenuDebug();

    if (cartMediaQuery && cartMediaQuery.addEventListener) {
      cartMediaQuery.addEventListener('change', assignCartIds);
    } else if (cartMediaQuery && cartMediaQuery.addListener) {
      cartMediaQuery.addListener(assignCartIds);
    } else {
      window.addEventListener('resize', assignCartIds);
    }

    if (window.MutationObserver) {
      if (mobileCartCount) {
        new MutationObserver(function () {
          syncCartText(mobileCartCount, mobileCartCost);
        }).observe(mobileCartCount, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }

      if (desktopCartCount) {
        new MutationObserver(function () {
          syncCartText(desktopCartCount, desktopCartCost);
        }).observe(desktopCartCount, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  });
})();
